"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const Integration_1 = require("../Integration");
const SalesforceCategory_1 = require("./SalesforceCategory");
const SalesforceSendClassification_1 = require("./SalesforceSendClassification");
let Salesforce = class Salesforce extends Integration_1.Integration {
    constructor() {
        super(...arguments);
        this.integrationType = 'Salesforce';
        this.displayType = 'Salesforce';
        this.isESP = true;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", String)
], Salesforce.prototype, "integrationType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "displayType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false, nullable: false }),
    tslib_1.__metadata("design:type", Boolean)
], Salesforce.prototype, "useSalesforceApiVersionTwo", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    typeorm_1.Column({
        nullable: true,
        type: 'varchar',
    }),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceAccountId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Salesforce.prototype, "clientId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Salesforce.prototype, "clientSecret", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Salesforce.prototype, "clientSubDomain", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], Salesforce.prototype, "accessToken", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Date)
], Salesforce.prototype, "accessTokenExpiryDate", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], Salesforce.prototype, "canConnectToREST", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], Salesforce.prototype, "canConnectToSOAP", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "isESP", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceSendClassification_1.SalesforceSendClassification, { nullable: true }),
    typeorm_1.ManyToOne(() => SalesforceSendClassification_1.SalesforceSendClassification),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceSendClassification", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.RelationId((obj) => obj.salesforceSendClassification),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceSendClassificationId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.ManyToOne(() => SalesforceCategory_1.SalesforceCategory),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceOsmosysCategory", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((obj) => obj.salesforceContentCategory),
    tslib_1.__metadata("design:type", Number)
], Salesforce.prototype, "salesforceOsmosysCategoryId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.ManyToOne(() => SalesforceCategory_1.SalesforceCategory),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceUserInitiatedSendsCategory", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((obj) => obj.salesforceContentCategory),
    tslib_1.__metadata("design:type", Number)
], Salesforce.prototype, "salesforceUserInitiatedSendsCategoryId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.ManyToOne(() => SalesforceCategory_1.SalesforceCategory),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceAssetCategory", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((obj) => obj.salesforceContentCategory),
    tslib_1.__metadata("design:type", Number)
], Salesforce.prototype, "salesforceAssetCategoryId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.ManyToOne(() => SalesforceCategory_1.SalesforceCategory),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceContentCategory", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((obj) => obj.salesforceContentCategory),
    tslib_1.__metadata("design:type", Number)
], Salesforce.prototype, "salesforceContentCategoryId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.ManyToOne(() => SalesforceCategory_1.SalesforceCategory),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceSendCategory", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((obj) => obj.salesforceSendCategory),
    tslib_1.__metadata("design:type", Number)
], Salesforce.prototype, "salesforceSendCategoryId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => SalesforceCategory_1.SalesforceCategory, { nullable: true }),
    typeorm_1.ManyToOne(() => SalesforceCategory_1.SalesforceCategory),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceTestSendCategory", void 0);
tslib_1.__decorate([
    typeorm_1.RelationId((obj) => obj.salesforceTestSendCategory),
    tslib_1.__metadata("design:type", Object)
], Salesforce.prototype, "salesforceTestSendCategoryId", void 0);
Salesforce = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.ChildEntity()
], Salesforce);
exports.Salesforce = Salesforce;
//# sourceMappingURL=Salesforce.js.map